import { Message } from 'element-ui'
import { isOrderID , isWorkID } from '@/utils/validate'

// 11开头是公司测试手机号
export const phoneReg =
	/^(11[0-9]|13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/

export function isMobile(val) {
	return phoneReg.test(val)
}

/**
 * 工单报警参数问题校验
 * @returns 有问题true 没问题false
 * */ 
export function workOrderApiParamsVerify(params) { 
	const { work_id = 0, order_id = 0 } = params
	if (work_id && !isWorkID(work_id)) { 
		Message.warning('工单id格式不正确')
		return true
	}
	if (order_id && !isOrderID(order_id)) { 
		console.log(order_id)
		Message.warning('订单id格式不正确')
		return true
	}
	return false
}

